import { Injectable } from "@angular/core";
import {
  AiModel,
  AiRequestFeedbackModel,
  AiRoleModel,
  GeneralResModel,
  OpenAiModel,
} from "src/app/_models";
import { CommonResponse } from "src/app/_models/common-response.modle";
import { AiRequestlogModal, StudyModel } from "src/app/_models/study.model";
import { ApiService } from "../api/api.service";

@Injectable({
  providedIn: "root",
})
export class OpenAiService {
  private apiPATH = "OpenAI/";

  constructor(private _api: ApiService) {}

  getAIReport(request: OpenAiModel) {
    return this._api.post<any>(`${this.apiPATH}getAIReport`, request);
  }

  dicomToImageExtract(orderId: number, accessionNo: string) {
    return this._api.post<StudyModel>(
      `${this.apiPATH}dicomToImageExtract/${orderId}/${accessionNo}`,
      {}
    );
  }

  finalizeReportLoad(orderId: number) {
    return this._api.post<StudyModel>(
      `${this.apiPATH}finalizeReportLoad/${orderId}`,
      {}
    );
  }

  updateAiRequestfeedback(request: AiRequestFeedbackModel) {
    return this._api.post<GeneralResModel<AiRequestFeedbackModel>>(
      `${this.apiPATH}UpdateAiRequestfeedback`,
      request
    );
  }

  updateAiRequestfeedbackComments(request: AiRequestFeedbackModel) {
    return this._api.post<GeneralResModel<AiRequestFeedbackModel>>(
      `${this.apiPATH}UpdateAiRequestfeedbackComments`,
      request
    );
  }

  updateAiResponse(request: AiRequestlogModal) {
    return this._api.put<GeneralResModel<AiRequestlogModal>>(
      `${this.apiPATH}UpdateAiResponse`,
      request
    );
  }

  getRoleList() {
    return this._api.get<GeneralResModel<AiRoleModel[]>>(
      `${this.apiPATH}GetRoleList`
    );
  }
  AddAiRole(body: AiRoleModel) {
    return this._api.post<CommonResponse>(`${this.apiPATH}AddAiRole`, body);
  }
  UpdateAiRole(body: AiRoleModel) {
    return this._api.put<CommonResponse>(`${this.apiPATH}UpdateAiRole`, body);
  }
  GetAiRoleById(roleId: number) {
    return this._api.get<CommonResponse>(
      `${this.apiPATH}GetAiRoleById/${roleId}`
    );
  }
  GetNextAIRoleSL() {
    return this._api.get<any>(`${this.apiPATH}GetNextAIRoleSL`);
  }
  GetAiModelList() {
    return this._api.get<GeneralResModel<AiModel[]>>(
      `${this.apiPATH}GetAiModelList`
    );
  }
}
